var generateComponentTheme = function generateComponentTheme() {
  return {
    iconTransitionDuration: '0.3s'
  };
};
export default generateComponentTheme;